import { useParams } from "react-router";
import { MODELS, useModel } from "../../api";
import { ShellContent } from "../shell/Shell.jsx";
import tokens from "../../design-system/tokens.js";
import { useSparkContext } from "../workshops/context/SparkContext.jsx";
import { ShowroomFormArea } from "./ShowroomForm/ShowroomFormArea.jsx";

const TeamDiary = () => {
  const { smallTeamId } = useParams();
  const { spark } = useSparkContext();
  const smallTeam = useModel(MODELS.SMALL_TEAM({ smallTeamId: smallTeamId }));
  const showroomData = useModel(MODELS.SMALL_TEAM_SHOWROOM_ENTRY(smallTeam.id));

  return (
    <ShellContent bg={tokens.color.full.gray800}>
      <ShowroomFormArea
        smallTeam={smallTeam}
        projectFormDefinition={spark.projectFormDefinition}
        entry={showroomData.entry}
      />
    </ShellContent>
  );
};

export default TeamDiary;
